import React from "react";
import { Box } from "@chakra-ui/react";
import NetworkReportOverviewTab from "./report/pages/NetworkReportOverviewTab";

const NetworkDashboard = () => (
  <Box p={{ base: 4, md: 6 }} w="100%" maxW="100%" overflowX="hidden">
    <NetworkReportOverviewTab heading="Dashboard" />
  </Box>
);

export default NetworkDashboard;
